import { FETCH_GLOBAL_SETTINGS } from 'state/actions/ui/applicationUIActions';

const makeFragments = (simpleData) => {
  return simpleData.map((data) => {

    const d = Object.keys(data).map((key) => {
      return {
        key: key,
        value: data[key],
        type: 'Symbol'
      }
    });

    return [{ key: 'uuid', value: simpleData.indexOf(data) }, ...d];
  });
};


// When contentful is down, we fallback to showing only 
// these links in the menu, as none of these pages use 
// contentful.
const defaultMenu = makeFragments([{
  name: 'Light',
  link: '/'
}, {
  name: 'Shop',
  link: '/shop'
}, {
  name: 'Dashboard',
  link: '/dashboard'
}, {
  name: 'Support',
  link: '/support'
}]);

const initialState = {
  globalSettings: {
    items: [{
      fields: {
        siteWideBanner: '',
        siteWideBannerLink: '',
        footerLightPhoneIncAddress: 'the light phone inc. 19 morris avenue brooklyn, ny 11205',
        menu: {
          fragments: defaultMenu
        },
        footerBottomLinks: {
          fragments: []
        }
      }
    }],
  }
};

const reducer = (state = initialState, action) => {
  const { type } = action;
  switch (type) {
    case `${FETCH_GLOBAL_SETTINGS}_FULFILLED`:
      return {
        ...state,
        globalSettings: action.payload
      };
    default:
      return state;
  }
};

export default reducer;
